export const ADD_MESSAGE_VALUE = 'ADD_MESSAGE_VALUE/SALES-CHALLENGE';

export function addMessageValue(payload) {
  return {
    type: ADD_MESSAGE_VALUE,
    payload,
  };
}
